// components/ContactModal.jsx
import React, { useState } from 'react';
import { FaReddit, FaEnvelope, FaCopy, FaExternalLinkAlt } from 'react-icons/fa';

const ContactModal = ({ isOpen, onClose }) => {
  const emailAddress = 'support@shelbula.com';
  const [copySuccess, setCopySuccess] = useState('');

  if (!isOpen) return null;

  const handleCopyClick = async () => {
    try {
      await navigator.clipboard.writeText(emailAddress);
      setCopySuccess('Copied!');
      setTimeout(() => setCopySuccess(''), 2000);
    } catch (err) {
      setCopySuccess('Failed');
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: 'rgba(3, 7, 18, 0.85)' }}
      onClick={onClose}
    >
      <div 
        className="w-full max-w-md rounded-lg border overflow-hidden"
        style={{
          background: '#111827',
          borderColor: '#374151'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div 
          className="px-4 py-3 border-b flex items-center justify-between"
          style={{ 
            borderColor: '#374151',
            background: 'rgba(249, 115, 22, 0.05)'
          }}
        >
          <div>
            <h3 className="text-base font-semibold text-white">Contact Us</h3>
            <p className="text-sm text-gray-400">Choose your preferred method</p>
          </div>
          <button 
            onClick={onClose} 
            className="p-1 text-gray-400 hover:text-white transition-colors rounded"
            style={{ fontSize: '18px' }}
          >
            ×
          </button>
        </div>

        {/* Contact Methods */}
        <div className="p-4 space-y-3">
          {/* Email - Primary with dual options */}
          <div 
            className="p-3 rounded border"
            style={{
              background: 'rgba(249, 115, 22, 0.1)',
              borderColor: 'rgba(249, 115, 22, 0.3)'
            }}
          >
            <div className="flex items-center gap-3 mb-3">
              <div 
                className="w-8 h-8 rounded flex items-center justify-center flex-shrink-0"
                style={{ background: 'rgba(249, 115, 22, 0.2)' }}
              >
                <FaEnvelope className="w-4 h-4" style={{ color: '#f97316' }} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-white">Email Support</span>
                  <span 
                    className="text-xs px-2 py-0.5 rounded"
                    style={{ background: 'rgba(249, 115, 22, 0.2)', color: '#f97316' }}
                  >
                    Primary
                  </span>
                </div>
                <p className="text-xs text-gray-400">{emailAddress}</p>
              </div>
            </div>
            
            {/* Email Action Buttons */}
            <div className="flex gap-2">
              <a
                href={`https://mail.google.com/mail/?view=cm&fs=1&to=${emailAddress}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 px-3 py-2 text-sm rounded font-medium text-white transition-colors text-center"
                style={{ background: '#f97316' }}
                onMouseEnter={(e) => e.target.style.background = '#ea580c'}
                onMouseLeave={(e) => e.target.style.background = '#f97316'}
              >
                Open in Gmail
              </a>
              <a
                href={`mailto:${emailAddress}`}
                className="flex-1 px-3 py-2 text-sm rounded font-medium transition-colors border text-center"
                style={{ borderColor: '#f97316', color: '#f97316' }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#f97316';
                  e.target.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.color = '#f97316';
                }}
              >
                Open Email Client
              </a>
            </div>
          </div>

          {/* Reddit */}
          <div className="p-3 rounded border border-gray-600 bg-gray-800">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded flex items-center justify-center flex-shrink-0 bg-gray-700">
                <FaReddit className="w-4 h-4 text-gray-300" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-white">Reddit</span>
                  <span className="text-xs px-2 py-0.5 rounded bg-gray-700 text-gray-300">
                    2nd fastest
                  </span>
                </div>
                <p className="text-xs text-gray-400">u/Shelbula or r/Shelbula</p>
              </div>
              <a
                href="https://www.reddit.com/r/Shelbula"
                target="_blank"
                rel="noopener noreferrer"
                className="px-3 py-1.5 text-sm rounded font-medium transition-colors border text-gray-300 border-gray-600 hover:bg-gray-700"
              >
                Visit <FaExternalLinkAlt className="w-3 h-3 inline ml-1" />
              </a>
            </div>
          </div>
        </div>

        {/* Quick Copy Footer */}
        <div className="px-4 py-3 border-t bg-gray-800" style={{ borderColor: '#374151' }}>
          <div className="flex items-center justify-between">
            <span className="text-xs text-gray-400">Quick copy email address:</span>
            <button
              onClick={handleCopyClick}
              className="px-2 py-1 text-xs rounded border transition-colors text-gray-300 border-gray-600 hover:bg-gray-700"
            >
              <FaCopy className="w-2.5 h-2.5 inline mr-1" />
              {copySuccess || 'Copy'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;